var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CmStatTable',{attrs:{"isLoading":_vm.isLoading,"isError":_vm.isError,"value":_vm.value,"cols":_vm.cols,"isLongTable":_vm.isLongTable},on:{"open-long-table":function($event){return _vm.setLongTablePart(_vm.longTableId)}}})}
var staticRenderFns = []

export { render, staticRenderFns }